import { axiosInstance } from "./axios";

export const ResellersAPI = {

    /**
     * Retrieve resellers with optional pagination and search query.
     * @param {number} [limit=15] - Number of resellers per page.
     * @param {number} [page=1] - Current page number.
     * @param {string} [query=""] - Optional search query.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    getResellers: (limit = 15, page = 1, query = "", token = "") => {
        return axiosInstance(token).get(`/resellers?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
    },

    /**
     * Create a new reseller.
     * @param {Object} reseller - Reseller data.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    createReseller: (reseller, token = "") => {
        return axiosInstance(token).post(`/resellers`, reseller);
    },

    /**
     * Retrieve a reseller by ID.
     * @param {string} resellerId - The MongoDB ID of the reseller.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    getResellerById: (resellerId, token = "") => {
        return axiosInstance(token).get(`/resellers/${resellerId}`);
    },

    /**
     * Update a reseller by ID.
     * @param {string} resellerId - The MongoDB ID of the reseller.
     * @param {Object} reseller - Updated reseller data.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    updateResellerById: (resellerId, reseller, token = "") => {
        return axiosInstance(token).put(`/resellers/${resellerId}`, reseller);
    },

    /**
     * Delete a reseller by ID.
     * @param {string} resellerId - The MongoDB ID of the reseller.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    deleteResellerById: (resellerId, token = "") => {
        return axiosInstance(token).delete(`/resellers/${resellerId}`);
    },

    /**
     * Bulk delete resellers by IDs.
     * @param {Object} payload - Payload containing reseller IDs.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    bulkDeleteResellers: (payload, token = "") => {
        return axiosInstance(token).delete(`/resellers`, { data: payload });
    },
    /**
     * Partially update a reseller by ID.
     * @param {string} resellerId - The MongoDB ID of the reseller.
     * @param {Object} payload - Partial reseller data to update.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    patchResellerById: (resellerId, payload, token = "") => {
        return axiosInstance(token).patch(`/resellers/${resellerId}`, payload);
    },

    /**
     * Export resellers by IDs.
     * @param {Array} ids - Array of reseller IDs to export.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    exportResellers: (ids = [], token = "") => {
        return axiosInstance(token).post(`/resellers/exports`, { ids: ids });
    }
};
